import React from "react"
import { graphql } from "gatsby"

import CardCarousel from '../components/card_carousel'
import CTACallout from "../components/cta_callout"
import DemoSection from "../components/demo_section"
import HeadlineCallout from '../components/headline_callout'
import Hero from '../components/hero'
import ImageAndBlurb from '../components/image_and_blurb'
import Infographic from '../components/infographic'
import Layout from "../components/layout"
import LargeImageAndBlurb from "../components/large_image_and_blurb"
import StudyCarousel from '../components/study_carousel'
import Seo from "../components/seo"
import ThinBlurb from "../components/thin_blurb"
import TwoTonedImageAndBlurb from "../components/two_toned_image_and_blurb"
import VideoSection from "../components/video-section.js"
import Gclid from "../components/gclid"

import { homepageSmsReview } from "../hooks/handleTwoTonedImageAndBlurb.js"

// Images
import seoImage from "../images/all-in-one-solution.png"
import { StaticImage } from "gatsby-plugin-image"

const HomePage = ({ data, location }) => {
  // const siteTitle = data.site.siteMetadata?.title || `Title`

  return (
    <Layout>
      <Hero 
        background
        boldBefore
        strapline="All-in-One Solution"
        headlineBold="Intelligent Solutions "
        headline="for Practice Growth"
        paragraph="Your all-in-one solution from new patient acquisition to retention. Our comprehensive all-in-one medical marketing solution 
        includes online scheduling, patient recall, automated review generation, intelligent call scoring, advanced site development, monthly 
        content creation and more.  We deliver a complete new patient acquisition to retention solution so you can focus on what matters: delivering 
        high quality care to your patients"
        buttonText ="Schedule a Free Demo"
        buttonHref="/demo"
        buttonTextTwo="See Success Stories"
        buttonHrefTwo="/resources/case-studies"
        image="all-in-one-solution.png"
      />
      {/* BEGIN : DGW-2898 : this is an example of how to use TitleTextButtonContent and InfoImage, please remove this from index after code review */}
      {/* <div className="container" style={{height:'600px'}}>
        <div className="row">
          <TitleTextButtonContent
            strongHeader="Example"
            regularHeader="Text Component"
            captionParagraph="Your all-in-one solution from new patient acquisition to
            retention. Our comprehensive all-in-one medical marketing solution
            includes online scheduling, patient recall, automated review
            generation, intelligent call scoring, advanced site development,
            monthly content creation and more. We deliver a complete new
            patient acquisition to retention solution so you can focus on what
            matters."
          />
          <div className="col-lg-7 d-flex justify-content-evenly">
            <InfoImage
            title="Dental Marketing"
            colSize={4}
            imageNum={1}
            />
            <InfoImage
            title="Healthcare Marketing"
            colSize={4}
            imageNum={2}
            />
          </div>
        </div>
      </div> */}
      
      <HeadlineCallout 
        strapline="Increase Your New Patient Inquiries" 
        headline="100% Performance Guarantee" 
      />

      <div>
        <div className="container mt-lg-5 pt-lg-5">
          <div className="row">
            <aside className="col-xl-3 col-md-12 col-sm-12">
              <ThinBlurb 
              boldAfter
              headline="Complete New "
              headlineBold="Patient Solution"
              paragraphOne="We are an all-in-one medical marketing company for healthcare providers who want to boost their online presence, improve their 
              patient’s experience, improve new patient acquisition, and more. Our exclusive all-in-one solution delivers a seamless new patient journey 
              from new patient generation, appointment scheduling, patient communication, and automated online reviews."
              paragraphTwo="We also deliver, manage, and maintain sites with continuous, fresh content to boost your online presence and ranking."
              />
            </aside>
            <div className="col-xl-9 col-md-12 col-sm-12 ps-xl-5">
              <CardCarousel />
            </div>
          </div>
        </div>
      </div>

      <LargeImageAndBlurb left
        image="enable-your-success.png"
        headline="Doctor Genius is built to "
        headlineBold="enable your success"
        paragraph="Our Patient Experience (PX) package automates patient engagement, scheduling, and reviews, putting your practice ahead of the curve.
        Intelligent call scoring enables you to better manage your practice, the team that represents it, and convert more new patients."
        strapline ="Performance, Results, Excellence"
        buttonHref="/marketing-solutions"
        buttonText="Understand Your Practice"
      />

      <ImageAndBlurb right
        image="seamless-campaign-management.png"
        headline="Seamless" 
        headlineBold="Campaign Management" 
        paragraph="The Doctor Genius platform enables you to easily understand how your campaign is performing. Choose how you manage your campaign. 
        You can review the monthly reporting sent straight to your inbox ranging from inquiries, analytics, to first page rankings or you can log into 
        your dashboard and dive into all that and more, all in one place. We eliminate the need for multiple platforms to cover your marketing efforts, 
        providing an all-in-one solution right at your fingertips."
        buttonHref="/portal-dashboard"
        buttonText="Doctor Genius Platform"
      />

      <VideoSection right
      headline="Since we've been working with Doctor Genius, consistently maybe"
      headlineBold="eighty or ninety percent of my patients tell me I found you online."
      buttonHref="/resources/case-studies"
      buttonText="View More Testimonials"
      paragraph='"Dr. Ashley Brede Ciapciak"'

      />

      <Infographic headlineBold="Trusted by thousands" headline="of happy doctors and customers since 2008." />

      <LargeImageAndBlurb left
        image="marketing-specialty.png"
        headline="Doctor Genius"
        headlineBold="Marketing Specialty"
        paragraph="Informed, proactive patients are more likely to interact with your practice, online and over the phone. This means increased ranking, communication, 
        new patient calls, and practice revenue. Implementing a marketing approach encourages both patient growth and retention, without the need for continuous communication 
        and outreach strategies. We set up automations to keep your practice up to date and in line with patient needs so they never look anywhere else."
        buttonHref="/marketing-solutions"
        buttonText="Our Services"
      />

      <LargeImageAndBlurb right bgOff
        image="automated-reviews.png"
        headline="Improve"
        headlineBold="Your Online Reputation"
        paragraph="Leverage our automation technology that seamlessly requests and gathers patient feedback so you can position your practice as a proactive and convenient solution for quality care."
        buttonHref="/px-patient-experience"
        buttonText="Our PX: Reviews"
      />
      <ImageAndBlurb
        image="appointments-sms.png"
        headline="SMS Review Request"
        paragraph="Instead of an email, send an SMS to patients that asks to leave a review for the practice."
        buttonHref="/px-patient-experience"
        buttonText="Our PX: Reviews"
      />
      <TwoTonedImageAndBlurb contentProps={homepageSmsReview} left />

      <CTACallout
        headline="Get your practice to the next level "
        headlineBold="Explore Doctor Genius Plans"
        buttonText="Plans & Recomendations"
        buttonHref="/plans"
      />

      <div>
        <div className="container mt-lg-5 pt-lg-5">
          <div className="row">
            <aside className="col-xl-3 col-md-12 col-sm-12">
              <ThinBlurb 
              boldBefore
              headline="The Resources
              You need"
              headlineBold="The Study: "
              paragraphOne="Current and updated news, education, and viable information on all things Practice Management and Digital Marketing to help jumpstart your practice and keep it relevant. Dive in and get the most out of the resources you may need now or in the future."
              />
            </aside>
            <div className="col-xl-9 col-md-12 col-sm-12 ps-xl-5">
              <StudyCarousel posts={ data } />
            </div>
          </div>
        </div>
      </div>
      <DemoSection
        right
        boldAfter
        headline="Start Your Success with "
        headlineBold ="Doctor Genius Today!"
        paragraph="From new patient acquisition to retention, Doctor Genius has you covered. Explore our plans and features to determine your practice’s best option."
        buttonHref="/demo"
      />
      <Gclid />
    </Layout>
  )
}

export default HomePage


/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo image={`https://doctorgenius.com` + seoImage} title="High Conversion Patient Acquisition Websites | Performance, Results, Excellence" description="Start acquiring the new patients your healthcare practice deserves. Mobile first conversion focused medical websites combined with performance digital marketing." />
// export const pageQuery = graphql`
//   {
//     site {
//       siteMetadata {
//         title
//       }
//     }
//     allMarkdownRemark(sort: { frontmatter: { date: DESC } }) {
//       nodes {
//         excerpt
//         fields {
//           slug
//         }
//         frontmatter {
//           date(formatString: "MMMM DD, YYYY")
//           title
//           description
//         }
//       }
//     }
//   }
// `

export const pageQuery = graphql`
  query WordPressPostArchive {
    allWpPost(
      sort: { date: DESC }
      limit: 4
    ) {
      nodes {
        excerpt
        uri
        date(formatString: "MMMM DD, YYYY")
        title
        excerpt
        slug
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(
                  quality: 100
                  placeholder: DOMINANT_COLOR
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
    }
  }
`
